import * as React from "react";
const Reconnect = ({ strokeColor = "var(--color-icon-obscure)", ...props }) => (
  <svg
    width={34}
    height={34}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={17} cy={17} r={17} fill="white" />
    <path
      d="M24.0177 17.1826C23.6761 17.1826 23.3927 16.8993 23.3927 16.5576V13.791C23.3927 12.7577 22.5511 11.916 21.5177 11.916H9.98438C9.64271 11.916 9.35938 11.6327 9.35938 11.291C9.35938 10.9493 9.64271 10.666 9.98438 10.666H21.5177C23.2427 10.666 24.6427 12.066 24.6427 13.791V16.5576C24.6427 16.9076 24.3594 17.1826 24.0177 17.1826Z"
      fill={strokeColor}
    />
    <path
      d="M12.6177 14.5576C12.4594 14.5576 12.301 14.4992 12.176 14.3742L9.54271 11.7409C9.42604 11.6242 9.35938 11.4659 9.35938 11.2992C9.35938 11.1326 9.42604 10.9742 9.54271 10.8576L12.176 8.22422C12.4177 7.98255 12.8177 7.98255 13.0594 8.22422C13.301 8.46589 13.301 8.86593 13.0594 9.1076L10.8677 11.2992L13.0594 13.4909C13.301 13.7326 13.301 14.1326 13.0594 14.3742C12.9344 14.4909 12.776 14.5576 12.6177 14.5576Z"
      fill={strokeColor}
    />
    <path
      d="M24.0177 23.3253H12.4844C10.7594 23.3253 9.35938 21.9253 9.35938 20.2003V17.4336C9.35938 17.0919 9.64271 16.8086 9.98438 16.8086C10.326 16.8086 10.6094 17.0919 10.6094 17.4336V20.2003C10.6094 21.2336 11.451 22.0753 12.4844 22.0753H24.0177C24.3594 22.0753 24.6427 22.3586 24.6427 22.7003C24.6427 23.0419 24.3594 23.3253 24.0177 23.3253Z"
      fill={strokeColor}
    />
    <path
      d="M21.3827 25.9579C21.2243 25.9579 21.066 25.8996 20.941 25.7746C20.6993 25.5329 20.6993 25.1329 20.941 24.8912L23.1327 22.6996L20.941 20.5079C20.6993 20.2663 20.6993 19.8663 20.941 19.6246C21.1827 19.3829 21.5827 19.3829 21.8243 19.6246L24.4577 22.2579C24.5744 22.3746 24.641 22.5329 24.641 22.6996C24.641 22.8663 24.5744 23.0246 24.4577 23.1413L21.8243 25.7746C21.7077 25.8996 21.5493 25.9579 21.3827 25.9579Z"
      fill="#292D32"
    />
  </svg>
);
export default Reconnect;
